import React from "react";
import PopoverButton from "@ui-kit/popover/button";
import { Clause } from "@radarly/models/clause";
import Popover from "./popover";

interface IProps {
  clause: Clause;
  onOpenChange?: (open: boolean) => void;
  side?: "left" | "right" | "top" | "bottom";
}

const RadarlyCardsActionScope = ({ clause, onOpenChange, side }: IProps) => (
  <PopoverButton onOpenChange={onOpenChange} side={side}>
    <Popover clause={clause} />
  </PopoverButton>
);

export default RadarlyCardsActionScope;
